var _path, _path2, _mask, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.538 5.26399C4.86631 7.85263 3.19462 10.4413 1.52293 13.0299C-0.0135802 15.409 0.495587 18.2951 2.92427 20.1988C4.08904 21.1113 5.47461 21.6362 6.8061 21.6497C8.92613 21.67 10.6068 20.3836 11.7491 18.802C13.0918 16.941 13.0783 14.6858 11.7739 12.8069L6.538 5.26399Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 5.06353L9.13792 0.649994H4.04175L6.58984 5.06353Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_461_1290",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.45751 4.70309H4.69958V5.74846H8.45751V4.70309Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45751 4.70309H4.69958V5.74846H8.45751V4.70309Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69958 4.70309V3.40309H3.39959V4.70309H4.69958ZM8.45751 4.70309H9.75751V3.40309H8.45751V4.70309ZM8.45751 5.74846V7.04846H9.75751V5.74846H8.45751ZM4.69958 5.74846H3.39959V7.04846H4.69958V5.74846ZM4.69958 4.70309V6.00309H8.45751V4.70309V3.40309H4.69958V4.70309ZM8.45751 4.70309H7.15751V5.74846H8.45751H9.75751V4.70309H8.45751ZM8.45751 5.74846V4.44846H4.69958V5.74846V7.04846H8.45751V5.74846ZM4.69958 5.74846H5.99958V4.70309H4.69958H3.39959V5.74846H4.69958Z",
    fill: "#1A1C40",
    mask: "url(#path-3-inside-1_461_1290)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.6ec95432c901c3b43e674e03b50e7714.svg";
export { ForwardRef as ReactComponent };